import { Card, ListLayout, PileBadge } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

import { ShipmentTemplateDetails } from '../types';

interface Props {
  template: Pick<ShipmentTemplateDetails, 'name' | 'tags'>;
}

export function BasicInformation({ template }: Props) {
  const { t } = useTranslation();

  return (
    <Card.List>
      <Card.Wrapper>
        <Card.Header>{t('common.basicInformation')}</Card.Header>
        <Card.Content>
          <ListLayout.Column>
            <ListLayout.Row>
              <ListLayout.Stack>
                <ListLayout.SecondaryText>{t('shipmentTemplates.details.templateName')}</ListLayout.SecondaryText>
                <ListLayout.PrimaryText>{template.name}</ListLayout.PrimaryText>
              </ListLayout.Stack>
            </ListLayout.Row>

            <ListLayout.Row>
              <ListLayout.Stack style={{ gap: '8px' }}>
                <ListLayout.SecondaryText>{t('common.tags')}</ListLayout.SecondaryText>
                <ListLayout.Row style={{ gap: '8px' }}>
                  {template.tags?.map(tag => (
                    <PileBadge variant="neutral" key={tag.id}>
                      {tag.name}
                    </PileBadge>
                  ))}
                </ListLayout.Row>
              </ListLayout.Stack>
            </ListLayout.Row>
          </ListLayout.Column>
        </Card.Content>
      </Card.Wrapper>
    </Card.List>
  );
}
